import AccountTreeIcon from "@material-ui/icons/AccountTree";
import ExtensionIcon from "@material-ui/icons/Extension";
import MeditocHelper from "../../../utils/MeditocHelper";
import WebIcon from "@material-ui/icons/Web";

export default function Simbologia() {
    return (
        <MeditocHelper title="Simbología:">
            <div>
                <AccountTreeIcon className={"color-1 vertical-align-middle"} />
                {"  "}
                Módulos
            </div>
            <div>
                <WebIcon className={"color-2 vertical-align-middle"} />
                {"  "}
                Submódulos
            </div>
            <div>
                <ExtensionIcon className={"color-3 vertical-align-middle"} />
                {"  "}
                Botones
            </div>
        </MeditocHelper>
    );
}
